var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-view"},[_c('div',{staticClass:"progress-container"},[_c('b-progress',{attrs:{"type":"is-primary","size":"is-small"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }